import Cookies from "js-cookie";

const showSplitTestWidget = async () => {
  const { mountSplitTestWidget } = await import(
    /* webpackChunkName: "split-test-widget" */
    "./splitTestWidget"
  );

  mountSplitTestWidget();
};

if (typeof window !== "undefined") {
  window.showSplitTestWidget = showSplitTestWidget;

  const splitTestVariants = JSON.parse(Cookies.get("test-available") || "[]");

  if (process.env.GATSBY_SHOW_SPLITTESTWIDGET?.toLowerCase() === "true" && splitTestVariants.length > 0) {
    showSplitTestWidget();
  }
}
